// The filter-chip class register shared by the report surface's chip rows:
// pill-shaped, 28px tall, brand-tinted when active, slate when not.
//
// It lives in its own leaf module rather than inside either chip component so
// that a second row cannot quietly drift from the first. The reporting-range
// chips and the record-type chips sit on the same line of the delivery
// report, where any difference in height, radius or active tint reads as a
// rendering fault.

export const CHIP_BASE =
  "inline-flex items-center h-7 px-2.5 rounded-full border text-caption font-medium transition-colors focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-400";

export const CHIP_ACTIVE =
  "border-brand-400 bg-brand-50 text-brand-700 dark:border-brand-500 dark:bg-brand-950 dark:text-brand-400";

export const CHIP_INACTIVE =
  "border-slate-300 bg-white text-slate-600 hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700";
